import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Modal } from "antd";
import ds from "../Services/DataServices";
import { useHistory } from "react-router-dom";
import { useStore, useDispatch, useSelector } from "react-redux";
import IntlMessages from "../util/IntlMessages";
import { loadIsDayPast } from "../appRedux/actions/CommonData";

const RegOpenDialog = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { Meta } = Card;

  const getReduxRegOpenInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsDayPast
  );
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [visible, setVisible] = React.useState(false);

  return (
    <Modal
    title={
      <strong><IntlMessages id="reg.opendialog.title" /></strong>
      }
    
      centered
      visible={getReduxRegOpenInfo}
      // width={1000}
      footer={
        <>
        <Button className="dk-btn-cancel mb-2" type="primary" onClick={() => { dispatch(loadIsDayPast(false)); }}>
              <IntlMessages id="reg.opendialog.canbtn" />
            </Button>
            <Button className="dk-btn-add mb-2" type="primary" onClick={() => { dispatch(loadIsDayPast(false)); history.push("/dashboard/sell/openclose/listing"); }} >
              <IntlMessages id="reg.opendialog.okbtn" />
            </Button>
            </>
      }
      onCancel={() => dispatch(loadIsDayPast(false))}
      className="Sell-Screen-Modal"
    >
    
<h2 className="gx-text-danger"><IntlMessages id="reg.opendialog.title2" /></h2>
<p className="mb-0"><IntlMessages id="reg.opendialog.desc" /></p>

    </Modal>
  );
};

export default RegOpenDialog;
